import React from 'react'
import type { Icon } from 'shared/utils'

const Egg = (props: Icon) => {
    const { color = 'black', size = 24, className = 'egg' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                d="M20.32 5.236C19.134 3.15 17.61 2 16.03 2c-2.065 0-3.783 1.981-4.826 4.356.247-.022.497-.048.736-.048.253 0 .497.017.738.042.861-1.71 2.085-2.991 3.353-2.991 1.057 0 2.189.928 3.11 2.549.89 1.568 1.442 3.564 1.442 5.209 0 1.554-.49 3.01-1.378 4.097-.841 1.028-1.942 1.6-3.106 1.621-.222.45-.467.889-.733 1.314.218.028.441.048.666.048 1.605 0 3.106-.754 4.224-2.125 1.087-1.33 1.686-3.09 1.685-4.956 0-1.894-.607-4.093-1.622-5.88m-5.355 3.512c-.708-.708-1.754-1.083-3.023-1.083-2.464 0-5.66 1.41-7.601 3.35-2.76 2.76-3.132 6.881-.828 9.185.979.98 2.342 1.52 3.84 1.52 1.907 0 3.856-.856 5.346-2.347 1.34-1.339 2.465-3.322 3.013-5.303.635-2.314.37-4.204-.747-5.322z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Egg }
